import httpService from '../Api/http.service';
import { getApiBaseUrl } from 'utils';

const getAdminBaseUrl = () => `${getApiBaseUrl()}/mgt`;

/**
 * Export file for a specific level and level_id
 * @param {string} level - The level type (e.g., 'group', 'revshare')
 * @param {string} levelId - The ID of the level
 * @param {object} data - The data to send (selected fields, etc.)
 * @returns {Promise}
 */
const exportFile = (level, levelId, data) =>
  httpService({
    url: `${getAdminBaseUrl()}/${level}/${levelId}/file-export`,
    method: 'post',
    data,
    headers: {
      Accept: 'application/json',
    },
  });

/**
 * Make file import HTTP request
 * @param {string} level - The level type (e.g., 'group', 'revshare')
 * @param {FormData} data - The form data containing the file and metadata
 * @returns {Promise}
 */
const makeFileImportRequest = (level, data) =>
  httpService({
    url: `${getAdminBaseUrl()}/${level}/file-import`,
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
  });

const adminService = {
  exportFile,
  makeFileImportRequest,
};

export default adminService;
